import { Text, VStack } from "@chakra-ui/react";
import moment from "moment";
import { ContactCardIcon } from "../../../../../icons/svg";
import Activity from "../Activity/Activity";

type SingleDispositionCardProps = {
  item: any;
};

function SingleDispositionCard({ item }: SingleDispositionCardProps) {
  return (
    <Activity
      key={item.id}
      id={item.id}
      //   handleClick={() => setClickedRecord(item)}
      title="Contact Disposition"
      dateAndTime={moment(item.created_at).format("dddd MMM DD YY • hh:mm a")}
      icon={<ContactCardIcon />}
      content={
        <VStack alignItems="flex-start" gap="0.25rem">
          <Text color="var(--grey-800)" textStyle="h6" fontWeight="500">
            Disposition Name: {item?.details?.name}
          </Text>
          <Text color="var(--grey-800)" textStyle="h6" fontWeight="500">
            Created By: {item?.details?.created_by ? item?.details?.created_by.by : "System"}
          </Text>
        </VStack>
      }
    />
  );
}

export default SingleDispositionCard;
